import { useOnlineStatus } from '@/hooks/useOnlineStatus'
import { AnimatePresence, motion } from 'framer-motion'
import { WifiOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function OfflineBanner() {
  const isOnline = useOnlineStatus()
  const { t } = useTranslation('common')
  return (
    <AnimatePresence>
      {!isOnline ? (
        <motion.div
          // biome-ignore lint/a11y/useSemanticElements: motion.div needs role="status" — <output> cannot be animated here
          role="status"
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="pointer-events-none fixed inset-x-0 top-3 z-50 flex justify-center px-4"
        >
          <div className="pointer-events-auto flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-4 py-1.5 text-xs font-medium text-amber-900 shadow-sm dark:border-amber-900/60 dark:bg-amber-950/70 dark:text-amber-200">
            <span className="flex h-2 w-2 items-center justify-center">
              <span className="absolute h-2 w-2 animate-ping rounded-full bg-amber-400 opacity-75" />
              <span className="relative h-1.5 w-1.5 rounded-full bg-amber-500" />
            </span>
            <WifiOff className="h-3.5 w-3.5" aria-hidden="true" />
            <span>{t('offline_message')}</span>
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}
